import { styled as e } from "styled-components";
//#region src/components/Carousel/styled/CarouselLayouts.styled.ts
var t = e.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme: e }) => e.spacing(1)};
    width: 100%;
    height: 100%;
`, n = e.div`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(1)};
    position: relative;
    width: 100%;
    height: 100%;
    flex: 1;
    min-height: 0;
`, r = e.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme: e }) => e.spacing(1)};
    align-items: stretch;
    width: 100%;
`, i = e.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: ${({ theme: e }) => e.spacing(1)};
`, a = e.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${({ theme: e }) => e.spacing(.75)};
`;
//#endregion
export { t as HorizontalLayout, n as HorizontalTrackRow, i as VerticalArrowRow, a as VerticalDots, r as VerticalLayout };
